import React, { createContext, useState, useEffect } from 'react';
import ru from './locales/ru';
import en from './locales/en';
import mn from './locales/mn';

const locales = { ru, en, mn };
const LANG_KEY = 'sto_language';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved && locales[saved]) return saved;
    const browserLang = navigator.language?.slice(0, 2);
    if (locales[browserLang]) return browserLang;
    return 'ru';
  });

  useEffect(() => {
    localStorage.setItem(LANG_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const keys = key.split('.');
    let value = locales[lang];
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        let fallback = locales['ru'];
        for (const fk of keys) { fallback = fallback?.[fk]; }
        return fallback || key;
      }
    }
    return value || key;
  };

  const phone = lang === 'ru' ? '+976 90504747' : '+976 90999907';

  const switchLanguage = (newLang) => { if (locales[newLang]) setLang(newLang); };

  const availableLanguages = [
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'mn', name: 'Монгол', flag: '🇲🇳' },
  ];

  return (
    <LanguageContext.Provider value={{ lang, t, phone, switchLanguage, availableLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
};